import React, {
  useEffect,
  useMemo,
  useState,
} from "react";

import axios from "../../../utills/api";

import {
  Card,
  CardBody,
  Button,
  Input,
  Badge,
  Row,
  Col,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
} from "reactstrap";

import {
  RiShoppingCart2Line,
  RiAddLine,
  RiSubtractLine,
  RiSearchLine,
} from "react-icons/ri";

const FoodOrder = ({ booking, roomNumber }) => {
  const [categories, setCategories] =
    useState([]);

  const [products, setProducts] =
    useState([]);

  const [cart, setCart] =
    useState([]);

  const [search, setSearch] =
    useState("");

  const [selectedCategory, setSelectedCategory] =
    useState("All");

  const [loading, setLoading] =
    useState(false);

  const [cartModal, setCartModal] =
    useState(false);

  useEffect(() => {
    loadData();
  }, []);

  const loadData = async () => {
    try {
      const [
        categoryRes,
        productRes,
      ] = await Promise.all([

        axios.get(
          "/menu/menu-settings/guest",
          {
            headers: {
              "x-tenant-id":
                booking.tenantId,
            },
          }
        ),

        axios.get(
          "/products/guest",
          {
            headers: {
              "x-tenant-id":
                booking.tenantId,
            },
          }
        ),

      ]);

      setCategories(
        categoryRes.data || []
      );

      setProducts(
        (productRes.data || []).filter(
          (p) =>
            p.status === "Active"
        )
      );
    } catch (err) {
      console.log(err);
    }
  };

  const getText = (value) => {
    if (!value) return "";

    if (typeof value === "string") return value;

    if (typeof value === "object") {
      return value.en || value.hi || Object.values(value)[0] || "";
    }

    return String(value);
  };

  const filteredProducts = useMemo(() => {
    return products.filter((item) => {
      const categoryMatch =
        selectedCategory === "All" ||
        getText(item.category) === selectedCategory;

      const searchMatch = getText(item.name)
        .toLowerCase()
        .includes(search.toLowerCase());

      return categoryMatch && searchMatch;
    });
  }, [
    products,
    selectedCategory,
    search,
  ]);

  const addToCart = (
    product
  ) => {
    const exists =
      cart.find(
        (c) =>
          c.itemId ===
          product._id
      );

    if (exists) {
      setCart(
        cart.map((c) =>
          c.itemId ===
            product._id
            ? {
              ...c,
              quantity:
                c.quantity + 1,
            }
            : c
        )
      );
    } else {
      setCart([
        ...cart,
        {
          itemId: product._id,
          name: getText(product.name),   // ✅ Store the localized string
          quantity: 1,
          price:
            product.discountedPrice > 0
              ? product.discountedPrice
              : product.price,
        }
      ]);
    }
  };

  const increaseQty = (
    itemId
  ) => {
    setCart(
      cart.map((item) =>
        item.itemId === itemId
          ? {
            ...item,
            quantity:
              item.quantity +
              1,
          }
          : item
      )
    );
  };

  const decreaseQty = (
    itemId
  ) => {
    setCart(
      cart
        .map((item) =>
          item.itemId === itemId
            ? {
              ...item,
              quantity:
                item.quantity -
                1,
            }
            : item
        )
        .filter(
          (i) =>
            i.quantity > 0
        )
    );
  };

  const totalAmount =
    cart.reduce(
      (
        total,
        item
      ) =>
        total +
        item.price *
        item.quantity,
      0
    );

  const placeOrder =
    async () => {
      try {
        setLoading(true);

        await axios.post(
  "/food/order",
  {
    tenantId: booking.tenantId,
    bookingId: booking.bookingId,
    mobile: booking.mobile,

    // Correct room from URL
    roomNumber,

    discountAmount: 0,
    items: cart,
  },
  {
    headers: {
      "x-tenant-id":
        booking.tenantId,
    },
  }
);

        alert(
          "Order Placed Successfully"
        );

        setCart([]);

        setCartModal(false);
      } catch (err) {
        console.log(err);

        alert(
          "Failed To Place Order"
        );
      } finally {
        setLoading(false);
      }
    };

  return (
    <>
      <div className="mb-3">

        <div className="position-relative">

          <RiSearchLine
            style={{
              position:
                "absolute",
              left: 12,
              top: 12,
            }}
          />

          <Input
            value={search}
            onChange={(e) =>
              setSearch(
                e.target.value
              )
            }
            placeholder="Search Food..."
            style={{
              paddingLeft:
                "35px",
            }}
          />
        </div>

      </div>

      {/* CATEGORY */}

      <div
        className="d-flex gap-2 mb-3"
        style={{
          overflowX:
            "auto",
        }}
      >
        <Button
          size="sm"
          color={
            selectedCategory ===
              "All"
              ? "success"
              : "light"
          }
          onClick={() =>
            setSelectedCategory(
              "All"
            )
          }
        >
          All
        </Button>

        {categories.map(
          (cat) => (
            <Button
              key={cat._id}
              size="sm"
              color={
                selectedCategory ===
                  cat.name
                  ? "success"
                  : "light"
              }
              onClick={() =>
                setSelectedCategory(
                  cat.name
                )
              }
            >
              {cat.name}
            </Button>
          )
        )}

      </div>

      <Row className="g-3">

        {filteredProducts.map(
          (product) => (

            <Col
              xs={6}
              key={product._id}
            >

              <Card
                className="border-0 shadow-sm"
                style={{
                  borderRadius: 16,
                  padding: 8,
                }}
              >

                <Row className="align-items-center g-2">


                  {/* IMAGE */}

                  <Col xs={5}>

                    <div
                      style={{
                        width: "100%",
                        aspectRatio: "1/1",
                        borderRadius: 14,
                        overflow: "hidden",
                        background:
                          "#f5f5f5",
                      }}
                    >

                      <img
                        src={
                          product.image
                        }
                        alt=""
                        style={{
                          width:
                            "100%",
                          height:
                            "100%",
                          objectFit:
                            "cover",
                        }}
                      />

                    </div>

                  </Col>



                  {/* DETAILS */}

                  <Col xs={7}>

                    <div>

                      <div
                        className="d-flex justify-content-between align-items-start"
                      >

                        <h6
                          className="mb-1"
                          style={{
                            fontSize:
                              13,
                            fontWeight:
                              600,
                          }}
                        >
                          {getText(product.name)}

                        </h6>


                        <Badge
                          color={
                            product.type === "Veg"
                              ? "success"
                              : "danger"
                          }
                          pill
                          style={{
                            fontSize:
                              9,
                          }}
                        >
                          {
                            product.type
                          }
                        </Badge>

                      </div>


                      <div
                        className="fw-bold"
                        style={{
                          fontSize:
                            14,
                        }}
                      >

                        ₹
                        {
                          product.discountedPrice > 0
                            ? product.discountedPrice
                            : product.price
                        }

                      </div>


                    </div>


                  </Col>


                </Row>


                {/* ADD BUTTON */}

                <Button
                  color="success"
                  size="sm"
                  block
                  className="mt-2"
                  style={{
                    borderRadius: 10,
                  }}
                  onClick={() =>
                    addToCart(
                      product
                    )
                  }
                >
                  ADD
                </Button>


              </Card>

            </Col>

          )
        )}

      </Row>

      {/* CART BUTTON */}

      {cart.length > 0 && (
        <div
          style={{
            position:
              "fixed",
            bottom: 20,
            left: 20,
            right: 20,
            zIndex: 999,
          }}
        >
          <Button
            color="success"
            block
            onClick={() =>
              setCartModal(
                true
              )
            }
          >
            <RiShoppingCart2Line />

            {" "}
            {cart.length} Items

            {" • ₹"}

            {totalAmount}

          </Button>
        </div>
      )}

      {/* CART */}

      <Modal
        isOpen={cartModal}
        toggle={() =>
          setCartModal(
            false
          )
        }
      >
        <ModalHeader>
          Your Order
        </ModalHeader>

        <ModalBody>

          {cart.map(
            (item) => (
              <div
                key={
                  item.itemId
                }
                className="d-flex justify-content-between align-items-center mb-3"
              >

                <div>

                  <strong>
                    {getText(item.name)}
                  </strong>

                  <div>
                    ₹
                    {
                      item.price
                    }
                  </div>

                </div>

                <div className="d-flex align-items-center gap-2">

                  <Button
                    size="sm"
                    onClick={() =>
                      decreaseQty(
                        item.itemId
                      )
                    }
                  >
                    <RiSubtractLine />
                  </Button>

                  {item.quantity}

                  <Button
                    size="sm"
                    onClick={() =>
                      increaseQty(
                        item.itemId
                      )
                    }
                  >
                    <RiAddLine />
                  </Button>

                </div>

              </div>
            )
          )}

          <hr />

          <h5>
            Total :
            ₹
            {totalAmount}
          </h5>

        </ModalBody>

        <ModalFooter>

          <Button
            color="success"
            onClick={
              placeOrder
            }
            disabled={
              loading
            }
          >
            {loading
              ? "Placing..."
              : "Place Order"}
          </Button>

        </ModalFooter>

      </Modal>
    </>
  );
};

export default FoodOrder;